export { default } from './PermissionsGate';
